
import '../App.css';
import {FaReact} from "react-icons/fa";
import {SiJavascript} from "react-icons/si";
import {AiFillHtml5} from "react-icons/ai";
import {IoLogoCss3} from "react-icons/io";
import {IoLogoNodejs} from "react-icons/io";
import {DiMongodb} from "react-icons/di";
import {SiExpress} from "react-icons/si";
import {BiGitBranch} from "react-icons/bi";
import {SiRedux} from "react-icons/si";
import {SiRedis} from "react-icons/si";
import {SiStyledcomponents} from "react-icons/si";
import {AiOutlineConsoleSql} from "react-icons/ai";

function Skills({skillsRef}) {

  return (
    <div className="Skills" ref={skillsRef}>
      <h1>Skills</h1>
      <div className='Skills-Container'>
        <div className='SkillsCard'>
          <FaReact className='icons'/>
          <h3>React</h3>
        </div>
        <div className='SkillsCard'>
          <SiJavascript className='icons'/>
          <h3>Javascript</h3>
        </div>
        <div className='SkillsCard'>
          <AiFillHtml5 className='icons'/>
          <h3>HTML</h3>
        </div>
        <div className='SkillsCard'>
          <IoLogoCss3 className='icons'/>
          <h3>CSS</h3>
        </div>
        <div className='SkillsCard'>
          <IoLogoNodejs className='icons'/>
          <h3>NodeJS</h3>
        </div>
        <div className='SkillsCard'>
          <DiMongodb className='icons'/>
          <h3>MongoDB</h3>
        </div>
        <div className='SkillsCard'>
          <SiExpress className='icons'/>
          <h3>Express</h3>
        </div>
        <div className='SkillsCard'>
          <BiGitBranch className='icons'/>
          <h3>Git</h3>
        </div>
        <div className='SkillsCard'>
          <SiRedux className='icons'/>
          <h3>Redux</h3>
        </div>
        <div className='SkillsCard'>
          <SiRedis className='icons'/>
          <h3>Redis</h3>
        </div>
        <div className='SkillsCard'>
          <SiStyledcomponents className='icons'/>
          <h3>Styled</h3>
        </div>
        <div className='SkillsCard'>
          <AiOutlineConsoleSql className='icons'/>
          <h3>SQL</h3>
        </div>
      </div>
    </div>
  );
}

export default Skills;
